const layout = {
  col: {
    xs: { span: 22, offset: 1 },
    sm: { span: 18, offset: 3 },
    md: { span: 20, offset: 2 },
    lg: { span: 12, offset: 6 },
    xl: { span: 12, offset: 6 },
  },
  form: {
    labelCol: {
      xs: { span: 24 },
      md: { span: 6 },
      lg: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 18 },
      lg: { span: 18 },
    },
  },
};
export default layout;
